var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPopUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-pop-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-pop-up"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01374207,14.75 C6.01374207,14.5991561 6.08245243,14.4620253 6.17864693,14.3523207 L13.5443975,7.01582278 L15.3858351,5.16455696 C15.6194503,4.94514768 15.9767442,4.94514768 16.1966173,5.16455696 L18.8350951,7.82489451 C19.0549683,8.05801688 19.0549683,8.41455696 18.8350951,8.63396624 L9.62790698,17.82173 C9.5179704,17.9314346 9.38054968,17.9862869 9.22938689,17.9862869 L6.56342495,18 C6.41226216,18 6.27484144,17.9451477 6.16490486,17.835443 C6.05496829,17.7257384 6,17.5748945 6,17.4240506 L6.01374207,14.75 Z M15.7980973,6.37130802 L14.7536998,7.41350211 L16.6088795,9.26476793 L17.653277,8.22257384 L15.7980973,6.37130802 Z M7.15433404,14.9968354 L7.14059197,16.8481013 L9.00951374,16.8343882 L15.7980973,10.0738397 L13.9429175,8.22257384 L7.15433404,14.9968354 Z",
    id: "edit-copy-3",
    stroke: "#009846",
    strokeWidth: 0.4,
    fill: "#009846"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPopUp);
export default __webpack_public_path__ + "static/media/edit-pop-up.09c0b22c66dc8ccc32fa964dd298487d.svg";
export { ForwardRef as ReactComponent };